import { useEffect, useRef } from 'react';
import { useForm } from '../../../../../shared/form/useForm';
import {
	DetailsDefaultValues,
	IDetailsFormData,
} from '../types/IDetailsFormData';
import { COMMON_DEFAULT_VALUES } from './useDefaultValues';
import { useDetailsSchema } from './useDetailsSchema';

interface IOptions {
	defaultValues?: DetailsDefaultValues;
	requiresConsent: boolean;
}

export function useDetailsForm({ defaultValues, requiresConsent }: IOptions) {
	const isInitialRender = useRef(true);
	const validationSchema = useDetailsSchema({ requiresConsent });

	const form = useForm<IDetailsFormData>({
		mode: 'onSubmit',
		defaultValues: defaultValues ?? COMMON_DEFAULT_VALUES,
		validationSchema,
	});

	useEffect(
		() => {
			if (!isInitialRender.current) {
				form.reset(defaultValues ?? COMMON_DEFAULT_VALUES);
			}

			isInitialRender.current = false;
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[defaultValues],
	);

	return form;
}
